import { Typography, makeStyles, withStyles } from "@material-ui/core";

import { FC } from "react";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  calculatorInput: {
    border: "none",
    display: "flex",
    maxWidth: "100%",
    minWidth: "100%",
    height: "100%",
    borderRadius: "inherit",
    fontSize: "inherit",
    fontWeight: "bold",
    textAlign: "center",
  },
}));

export const CalculatorInput: FC<React.ComponentProps<"input">> = (props) => {
  const classes = useStyles();
  return <input className={classes.calculatorInput} {...props} />;
};
